import appConfig from '@src/app.config'
import Vue from 'vue'
import App from './app'
import router, { resetRouter } from '@router'
import store from '@state/store'
import i18n from '@src/locales'
import { gapi } from 'gapi-script'
import '@components/_globals'

import './plugins/element.js'
import './plugins/can.js'
import './plugins/echo.js'
import './plugins/global-data.js'
import './plugins/notification.js'

import '@src/directives/custom-loading'

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

// google login api 串接測試用
// const CLIENT_ID = '364808111211-0empte7eqfi8lj3simj9pmdbfu85rle7.apps.googleusercontent.com'

// gapi.load('client:auth2', () => {
//   gapi.auth2.init({
//     client_id: CLIENT_ID,
//   })
// })

// // 添加全局錯誤處理
// Vue.config.errorHandler = function (err, vm, info) {
//   // 處理 Element UI Tabs 組件的錯誤
//   if (err.message && err.message.includes('scrollToActiveTab')) {
//     console.warn('Element UI Tabs 組件銷毀時的已知問題，已忽略')
//     return
//   }
  
//   // 處理 NavigationDuplicated 錯誤
//   if (err.name === 'NavigationDuplicated') {
//     console.warn('路由重複導航，已忽略')
//     return
//   }
  
//   // 其他錯誤正常處理
//   console.error('Vue Error:', err, info)
// }

// // 處理未捕獲的 Promise 錯誤
// window.addEventListener('unhandledrejection', function (event) {
//   if (event.reason && event.reason.name === 'NavigationDuplicated') {
//     event.preventDefault()
//     console.warn('未處理的路由重複導航錯誤，已忽略')
//     return
//   }
  
//   if (event.reason && event.reason.message && event.reason.message.includes('scrollToActiveTab')) {
//     event.preventDefault()
//     console.warn('Element UI Tabs 組件銷毀時的已知問題，已忽略')
//     return
//   }
// })

Promise.all([store.dispatch('auth/init'), store.dispatch('device/init')]).then(() => {
  resetRouter()

  const app = new Vue({
    i18n,
    router,
    store,
    computed: {
      isTouchDevice() {
        return 'ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
      },
      isMobileDevice() {
        return /Mobi|Android/i.test(navigator.userAgent)
      },
      isSmallDevice() {
        return window.innerWidth < 576
      },
    },
    created: function() {
      this.initFrame()
      window.addEventListener('resize', this.initFrame)
    },
    methods: {
      initFrame() {
        const height = window.innerHeight
        document.querySelector('body').style.cssText = `height: ${height}px; `
        document.querySelector('#frame').style.cssText = `
          height: ${height}px;
          max-width: ${appConfig.appMaxWidth}px;width:${appConfig.appWidth}`
        document.querySelector('body').classList.add('show-frame')
      },
    },
    mounted() {
      if (process.env.VUE_APP_DEV_MODE === 'ipetbooking') {
        this.faviconUrl = '/favicon_ipetbooking.png'
      } else if (process.env.VUE_APP_DEV_MODE === 'dingbeauty') {
        this.faviconUrl = '/favicon_dingbeauty.png'
      }
      if(this.$store.state.auth.currentUser.merchantAlias === 'domei') {
        window.globalData.DOMEI_GTAG = true
      }
      const favicon = document.getElementById('dynamic-favicon')
      favicon.href = this.faviconUrl
    },
    render: (h) => h(App),
  }).$mount('#app')

  // If running e2e tests...
  if (process.env.VUE_APP_TEST === 'e2e') {
    // Attach the app to the window, which can be useful
    // for manually setting state in Cypress commands
    // such as `cy.logIn()`.
    window.__app__ = app
  }
})
